import React, { Component } from 'react';

import PropTypes from 'prop-types';

// Graphql
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';

// React Table
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import matchSorter from 'match-sorter';

// Components Imports
import UserDetail from './UserDetail';
import CustomLoader from './innerComponents/CustomLoader';

// Material UI Imports
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

// Material Icons Imports
import IconContentAdd from '@material-ui/icons/AddCircle';
import IconBack from '@material-ui/icons/ArrowBack';
import IconEdit from '@material-ui/icons/Edit';

import { Link } from 'react-router-dom';

// Assets imports
import '../styles/ReactTable.css';
import '../styles/UsersList.css';
import { compose } from 'recompose';

import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

// Lodash
import _ from 'lodash';
import UserTableActions from './innerComponents/UserTableActions';

const styles = {
  paperStyle: {
    // General styles for paper
    width: "60%",
    margin: "0 auto",
    height: "auto",
  }
}

class UsersList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showList: true,
      showDetail: false,
      selectedId: "1",
      selectedName: null,
      expiryDate: new Date(),
      selectedTab: 0,
      userFilters: [],
      archivedUserFilters: [],
    };
  }

  handleTabChange = (event, value) => {
    this.setState({ selectedTab: value });
  };

  _handleBackClick() {
    this.props.location.state.refetchDetail = false
    this.setState({
      showList: !this.state.showList,
      showDetail: !this.state.showDetail
    });
  }

  handleClick(info) {
    try {
      this.setState({
        selectedId: info.row.id,
        selectedName: info.row.fullName,
        showList: !this.state.showList,
        showDetail: !this.state.showDetail
      });

    }
    catch (e) {

    }
  }

  handleArchive() {
    this.props.all_users_query.refetch()
      .then(this.props.all_inactive_users_query.refetch())
      .then(this.setState({
        refetchDetail: true
      }));
  }

  componentDidMount() {
    if (this.props.location.state && this.props.location.state.refetch === true) {
      this.props.all_users_query.refetch().then(() => {
        this.props.location.state.refetch = false
        this.setState({
          refetchDetail: true
        })
      })
    } else if (this.props.location.state === undefined) {
      this.props.location.state = {
        refetch: false,
      }
    }
  }
  render() {

    const role = localStorage.getItem('current_user_role')
    const { classes } = this.props;

    // Check if the query response is being loaded
    if (this.props.all_users_query && this.props.all_users_query.loading) {
      return <CustomLoader label={'Loading'}/>
    }

    if (this.props.all_inactive_users_query && this.props.all_inactive_users_query.loading) {
      return <CustomLoader label={'Loading'}/>
    }

    // Check if there were errrors
    if (this.props.all_users_query && this.props.all_users_query.error) {
      return <div>Error</div>
    }

    if (this.props.all_inactive_users_query && this.props.all_inactive_users_query.error) {
      return <div>Error</div>
    }

    const active_users_id_int = this.props.all_users_query.users.map(user => {
      user.id = parseInt(user.id, 10)
      return user;
    })
    const all_active_users = _.orderBy(active_users_id_int, 'id', 'asc');

    const inactive_users_id_int = this.props.all_inactive_users_query.users.map(user => {
      user.id = parseInt(user.id, 10)
      return user;
    })
    const all_inactive_users = _.orderBy(inactive_users_id_int, 'id', 'asc');

    // console.log(all_users);
    const columns = [
      {
        Header: 'Id',
        accessor: 'id',
        filterable: false,
        maxWidth: 100
      },
      {
        Header: 'Name',
        // accessor: 'fullName'
        id: "fullName",
        accessor: d => d.fullName,
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["fullName"] }),
        filterAll: true
      }, {
        Header: 'Email',
        accessor: 'email',
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["email"] }),
        filterAll: true
      }, {
        Header: 'Role',
        accessor: 'role',
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["role"] }),
        filterAll: true
      }, {
        Header: 'Region',
        id: "regionName",
        accessor: d => d.region.name,
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["regionName"] }),
        filterAll: true
      }
    ]

    if (role === 'Admin' || role === 'Office') {
      columns.push({
        Header: 'Actions',
        filterable: false,
        sortable: false,
        Cell: c => <div className={classes.cell}><UserTableActions handler={this.handleArchive.bind(this)} user={c.original} /></div>
      })
    }

    let usersListNode;
    if (this.state.showList) {
      usersListNode =
        <div>
          {(role === 'Admin' || role === 'Office') && (<AppBar position='static'>
            <Tabs value={this.state.selectedTab} onChange={this.handleTabChange} fullWidth>
              <Tab label="Users" />
              <Tab label="Archived Users" />
            </Tabs>
          </AppBar>)}
          {this.state.selectedTab === 0 && (
            <div>
              <div className="UsersList-header">
                <div className="UsersList-title">
                  <span>Users List</span>
                </div>
                <div className="UsersList-actions">
                  <Button
                    color="primary"
                    component={Link}
                    to="/users/new"
                  > <IconContentAdd style={{ marginRight: 8 }} />Add User</Button>
                </div>
              </div>
              <div className="UsersList-table">
                <ReactTable
                  data={all_active_users}
                  filterable
                  columns={columns}
                  defaultPageSize={10}
                  className="-striped -highlight"
                  getTdProps={(state, rowInfo, column, instance) => {
                    const info = rowInfo;
                    return {
                      onClick: e => {
                        if (column.Header !== 'Actions') {
                          this.handleClick(info);
                        }
                      }
                    };
                  }}
                  filtered={this.state.userFilters}
                  onFilteredChange={filtered => this.setState({userFilters: filtered})}
                  />
              </div>
            </div>
          )}
          {this.state.selectedTab === 1 && (
            <div>
              <div className="UsersList-header">
                <div className="UsersList-title">
                  <span>Archived Users List</span>
                </div>
                <div className="UsersList-actions">

                </div>
              </div>
              <div className="UsersList-table">
                <ReactTable
                  data={all_inactive_users}
                  filterable
                  columns={columns}
                  defaultPageSize={10}
                  className="-striped -highlight"
                  getTdProps={(state, rowInfo, column, instance) => {
                    const info = rowInfo;
                    return {
                      onClick: e => {
                        if (column.Header !== 'Actions') {
                          this.handleClick(info);
                        }
                      }
                    };
                  }}
                  filtered={this.state.archivedUserFilters}
                  onFilteredChange={filtered => this.setState({archivedUserFilters: filtered})}
                  />
              </div>
            </div>
          )}
        </div>
    }

    let userDetailNode;
    if (this.state.showDetail) {
      userDetailNode =
        <div>
          <div className="UsersList-detailFooter">
            <Button variant="contained"
              color="primary"
              onClick={this._handleBackClick.bind(this)}
            ><IconBack style={{ marginRight: 8 }} /> Back</Button>
          </div>
          <div className="UsersList-header">
            <div className="UsersList-title">
              <span>{this.state.selectedName}</span>
            </div>
            <div className="NewProject-actions">
              <Button
                component={Link}
                color="primary"
                to={`/users/${this.state.selectedId}/edit`}
              ><IconEdit style={{ marginRight: 8 }} /> Edit</Button>
            </div>
          </div>
          <div className="UsersList-detailContent">
            <UserDetail history={this.props.history} selectedId={this.state.selectedId} expiryDate={this.state.expiryDate} refetch={this.state.refetchDetail} />
          </div>
          <div className="UsersList-detailFooter">
            <Button variant="contained"
              color="primary"
              onClick={this._handleBackClick.bind(this)}
            ><IconBack style={{ marginRight: 8 }} /> Back</Button>
          </div>
        </div>;
    }

    return (
      <Paper className={classes.paperStyle} elevation={1} >
        <div>
          {usersListNode}
          {userDetailNode}
        </div>
      </Paper>
    );
  }


}

UsersList.propTypes = {
  classes: PropTypes.object.isRequired,
};


// GraphQL Query
// const ALL_USERS_QUERY = gql`
// query {
//   users {
//     id
//     role
//     fullName
//     email
//     active
//     region{
//       name
//     }
//   }
// }
// `;

const ALL_ACTIVE_USERS_QUERY = gql`
query {
  users(filters:[{field:"active_eq", operand:"true"}]) {
    id
    role
    fullName
    email
    active
    region{
      name
    }
  }
}
`;

const ALL_INACTIVE_USERS_QUERY = gql`
query {
  users(filters:[{field:"active_eq", operand:"false"}]) {
    id
    role
    fullName
    email
    active
    region{
      name
    }
  }
}
`;

// Exporting the query
export default compose(
  graphql(ALL_ACTIVE_USERS_QUERY, { name: 'all_users_query' }),
  graphql(ALL_INACTIVE_USERS_QUERY, { name: 'all_inactive_users_query' }),
  withStyles(styles)
)(UsersList);



// WEBPACK FOOTER //
// src/components/UsersList.js